import { render, staticRenderFns } from "./ReportBuilderHistory.vue?vue&type=template&id=2e6a526b&"
import script from "./ReportBuilderHistory.vue?vue&type=script&lang=js&"
export * from "./ReportBuilderHistory.vue?vue&type=script&lang=js&"
import style0 from "./ReportBuilderHistory.vue?vue&type=style&index=0&id=2e6a526b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports